module.exports = __webpack_public_path__ + "static/img/manual-28.0b7f0b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/manual-28.png
// module id = jiQt
// module chunks = 4